import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { useParams } from 'src/routes/hooks';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import { StationeryDispatchEditView } from 'src/sections/stationery-dispatch/view';

export default function StationeryDispatchEditPage() {
  const params = useParams();

  const { id } = params;

  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title>Stationery Dispatch Edit</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.UPDATE_STATIONERY_DISPATCH,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <StationeryDispatchEditView id={`${id}`} />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
